import React, { Component } from 'react';
import { gql } from '@apollo/client';
import { Query } from '@apollo/react-components';
import { Breadcrumb } from 'antd';
import SpinnerError from '$components/library/SpinnerError';
import ReactTable from 'react-table';
import styles from './styles.scss';

const STAFF_GRANTS = gql`
  query StaffGrants {
    staffGrants {
      uuid
      scope
      source {
        ... on StaffUser {
          uuid
          email
        }
      }
      sourceType
      sourceUuid
      target {
        ... on Product {
          uuid
          slug
        }
      }
      targetType
      targetUuid
    }
  }
`;

class Grants extends Component {
  renderGrants = (grants) => {
    if (grants.length === 0) {
      return <div>No grants.</div>;
    }

    return (
      <ReactTable
        columns={[
          {
            id: 'scope',
            Header: 'scope',
            accessor: 'scope',
          },
          {
            id: 'source',
            Header: 'source',
            accessor: (d) => {
              if (d.source) {
                return d.source.email;
              }

              return `${d.sourceType}: ${d.sourceUuid}`;
            },
          },
          {
            id: 'target',
            Header: 'target',
            accessor: (d) => {
              if (d.target) {
                return d.target.slug;
              }

              if (d.targetUuid) {
                return `${d.targetType}: ${d.targetUuid}`;
              }

              return d.targetType;
            },
          },
        ]}
        data={grants}
        className="-striped -highlight"
      />
    );
  };

  render() {
    return (
      <div className={styles.layout}>
        <Breadcrumb>
          <Breadcrumb.Item>Grants</Breadcrumb.Item>
        </Breadcrumb>
        <br />
        <Query query={STAFF_GRANTS}>
          {({ loading, error, data }) => {
            if (loading || error) {
              return <SpinnerError error={error} />;
            }

            const { staffGrants: grants } = data;
            return this.renderGrants(grants);
          }}
        </Query>
      </div>
    );
  }
}

export default Grants;
